var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStats3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 397.2 193.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: url(#linear-gradient);\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n        stroke-width: 1.03px;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-2);\n        opacity: .19;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 114.39,
    y1: 241.85,
    x2: 281.88,
    y2: -48.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e7427e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#de4681"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#c7548a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#a16a99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#6c89ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#29b0c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08c4d6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 114.67,
    y1: 241.37,
    x2: 281.61,
    y2: -47.78,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 110.42,
    y1: 249.71,
    x2: 287.15,
    y2: -56.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d5182e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#cc1f34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#b53248"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#8f5267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#5a7e92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#17b6c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08c4d6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "index"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M375.2,187.34H21.08c-5.83-5.83-9.1-9.1-14.93-14.93V21.19c5.83-5.83,9.1-9.1,14.93-14.93h354.12c5.83,5.83,9.1,9.1,14.93,14.93v151.22c-5.83,5.83-9.1,9.1-14.93,14.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M375.2,187.34H21.08c-5.83-5.83-9.1-9.1-14.93-14.93V21.19c5.83-5.83,9.1-9.1,14.93-14.93h354.12c5.83,5.83,9.1,9.1,14.93,14.93v151.22c-5.83,5.83-9.1,9.1-14.93,14.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.01,193.31H12.73L.38,180.34v-82.96l1.02,1.51v81l11.75,12.33h51.13l.72,1.07ZM178.61.29H12.73L.38,13.25v32.32l1.02,1.07V13.69L13.16,1.36h164.43l1.02-1.07ZM324.12,0h-12.74l-1.02,1.07h12.74l1.02-1.07ZM302.42,0h-12.74l-1.02,1.07h12.74l1.02-1.07ZM279.84,0h-12.74l-1.02,1.07h12.74l1.02-1.07ZM256.83,0h-12.74l-1.02,1.07h12.74l1.02-1.07ZM347.18,0h-11.59l-1.02,1.07h11.59l1.02-1.07ZM384.84,0h-26.19l-1.02,1.07h26.79l11.75,12.33v166.21l-11.75,12.33h-212.11l1.02,1.07h211.51l12.35-12.96V12.96l-12.35-12.96ZM1.08,88.04c-.6,0-1.08.51-1.08,1.14s.48,1.14,1.08,1.14,1.08-.51,1.08-1.14-.48-1.14-1.08-1.14ZM1.08,80.69c-.6,0-1.08.51-1.08,1.14s.48,1.14,1.08,1.14,1.08-.51,1.08-1.14-.48-1.14-1.08-1.14ZM1.08,74.94c-.6,0-1.08.51-1.08,1.14s.48,1.14,1.08,1.14,1.08-.51,1.08-1.14-.48-1.14-1.08-1.14ZM152.71,192.46c0-.63-.48-1.14-1.08-1.14s-1.08.51-1.08,1.14.48,1.14,1.08,1.14,1.08-.51,1.08-1.14ZM159.72,192.46c0-.63-.48-1.14-1.08-1.14s-1.08.51-1.08,1.14.48,1.14,1.08,1.14,1.08-.51,1.08-1.14ZM165.2,192.46c0-.63-.48-1.14-1.08-1.14s-1.08.51-1.08,1.14.48,1.14,1.08,1.14,1.08-.51,1.08-1.14Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStats3);
export default __webpack_public_path__ + "static/media/stats 3.de9a616e052c60b9cf13ee3cc4b2ab80.svg";
export { ForwardRef as ReactComponent };